module.exports = __webpack_public_path__ + "static/media/rc11.e0602211.jpg";